import React from 'react';
import PropTypes from 'prop-types';
import RavenUtil from 'APP_ROOT/components/common/ravenUtil';

export default class EventMediaImage extends React.PureComponent {

    render() {

        console.log('EventMediaImage props:', this.props);
        console.log('pathname:', window.location.pathname);


        var dateLocalizedStringOverlay;
        var dateText;
        if (this.props.date) {
            var dateLocalizedString = RavenUtil.toDateString(this.props.date);
            dateLocalizedStringOverlay = <div className="timestamp-label">{dateLocalizedString}</div>
            dateText = <h1>{dateLocalizedString}</h1>
        }

        let pathname = window.location.pathname;
        
        if (pathname.endsWith('/snapshot')){
            return (
                <div className="event-image-preview">
                    <img src={this.props.previewImageUrl}></img>
                    {dateText}
                </div>
            )
        }
        else{
           return (
                <div className="event-image-preview">
                    <img src={this.props.previewImageUrl}></img>
                    {dateLocalizedStringOverlay}
                </div>
            ) 
        }    
    }
}

EventMediaImage.propTypes = {
    previewImageUrl: PropTypes.string.isRequired,
    date: PropTypes.instanceOf(Date)
};
